// How a bed loops. Two kinds of file:
//
//   crossfade  the end is not the start (orchestra beds): a second voice of the same file starts
//              `crossfade` seconds before the first ends and the two blend, equal power.
//
//     voice 1  ████████████████████████╲
//     voice 2                    ╱████████████████████████╲
//                                ^-- crossfade
//
//   seamless   the file was made to loop (CC0 fallbacks): decoded once and looped by the audio
//              clock, sample-exact. A streamed second voice cannot be started that precisely.

/** Crossfades shorter than this are click guards, not blends: the file loops on its own. */
export const SEAMLESS_BELOW_S = 0.5;

export type LoopKind = 'crossfade' | 'seamless';

export function loopKind(crossfade: number): LoopKind {
  return crossfade < SEAMLESS_BELOW_S ? 'seamless' : 'crossfade';
}

/** Seconds from `position` until the next voice must start; 0 when its moment has come. */
export function untilNextVoice(position: number, duration: number, crossfade: number): number {
  return Math.max(0, duration - crossfade - position);
}
